import { useCallback } from 'react';

import { UPGRADE_ORIGIN } from 'src/data/common';
import { getCustomerPlan } from 'src/data/subscription';
import * as events from 'src/lib/events';
import { PAGES, useTrackingEvent } from 'src/services';
import { useCustomerActions } from 'src/store';

export const useHandlers = () => {
  const customerActions = useCustomerActions();
  const trackingEvent = useTrackingEvent();

  const handleUpgradeClick = useCallback(
    (performancePredictionsCount) => {
      const currentCustomer = customerActions.getCurrentCustomer();
      const currentPlan = getCustomerPlan(currentCustomer);
      trackingEvent(events.PURCHASE.navbarPurchaseClick, {
        page: PAGES.homePage,
        origin: UPGRADE_ORIGIN.navigationSidebar,
        performancePredictionsCount,
      });
      events.trackCrmEvent(events.CRM_EVENT.clickedUpgradeButton, {
        cta: events.CRM_SUBSCRIPTION_ACTION.buyNow,
        origin: UPGRADE_ORIGIN.navigationSidebar,
        plan: events.convertSubscriptionPlanForCrm(currentPlan),
      });
    },
    [customerActions, trackingEvent]
  );

  return {
    handleUpgradeClick,
  };
};
